<template>
    <div class="flex">
        <h3 class="text-lg leading-6 font-medium text-secondaryColor mr-2">
            {{ value.label }} :
        </h3>
        <p>{{ value.value.label }}</p>
    </div>
</template>

<script>
export default {
    name: 'CategoryAttribute',
    props: ['value']
}
</script>

<style scoped></style>
